import type {ActionTypeLoggingAccessEnum} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {useCallback, useEffect} from 'react';
import {useLoggingAccessMutation} from '../../mutations/useLoggingAccessMutation';
import {usePatientData} from '../../pages/PatientData/hooks/usePatientData';

export const useMyHospitalizationLoggingAccess = (
	actionType: ActionTypeLoggingAccessEnum,
	stopAutoRun?: boolean,
) => {
	const {mutate: handleLoggingAccess} = useLoggingAccessMutation();
	const {data: patientData} = usePatientData();

	const handleLog = useCallback(() => {
		if (!patientData?.serviceCode) return;
		handleLoggingAccess({
			accessReference: patientData.serviceCode.toString(),
			actionType,
		});
	}, [patientData, actionType, handleLoggingAccess]);

	useEffect(() => {
		if (stopAutoRun) return;
		handleLog();
	}, [patientData, stopAutoRun, handleLog]);

	return {handleLog};
};
